import { reduxField } from '../../../reduxHelpers'
const { reducer, actions, saga } = reduxField.HR.NEXT_OF_KIN()
export { reducer, actions, saga }
